<script setup>
defineProps({
  errors: {
    type: Array,
    required: true,
  },
});
</script>

<template>
  <p class="field-error-message">
    {{ errors[0].$message }}
  </p>
</template>
